import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeadingBlockOneComponent } from './heading-block-one.component';

@NgModule({
  declarations: [HeadingBlockOneComponent],
  exports: [HeadingBlockOneComponent],
  imports: [
    CommonModule,
  ]
})
export class HeadingBlockOneModule { }
